<template>
  <section class="page__not__found">
    <small>oopss...</small>
    <h1>Página não encontrada</h1>

    <img
      class="image"
      :src="require('@/assets/svg/404.svg')"
      alt="Logo do sistema"
    />

    <span>Desculpe, não encontramos a página que você está procurando.</span>

    <section class="footer">
      <v-btn
        class="border__radius-10"
        height="45"
        depressed
        color="primary"
        @click="goBack"
      >
        Retornar
      </v-btn>

      <v-btn
        class="border__radius-10"
        height="45"
        depressed
        to="/perguntas-frequentes"
      >
        Página de suporte
      </v-btn>
    </section>
  </section>
</template>

<script>
export default {
  name: "PageNotFoundView",

  methods: {
    goBack() {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.page__not__found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  text-align: center;

  .image {
    width: 650px;
  }

  .footer {
    display: flex;
    gap: 15px;
    margin-top: 15px;
  }
}
</style>
